import React, { useState,useEffect } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './olvidasteContrasenia.css';
import logoClaro from '../images/Logo.png';
import logoDark from '../img/logoDark.png';
const OlvidasteContrasenia = ({ handleTabChange }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const auth = getAuth();
  const navigate = useNavigate();
const [logo, setLogo] = useState(logoDark);
  useEffect(() => {
    if (localStorage.getItem('darkMode') === 'true') {
      setLogo(logoDark);
    } else {
      setLogo(logoClaro);
    }
  }, []);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordReset = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const resetUrl = `${window.location.origin}/reset-password?email=${encodeURIComponent(email)}`;
      await sendPasswordResetEmail(auth, email, { url: resetUrl });
      setMessage('Correo de restablecimiento enviado. Revisa tu bandeja de entrada.');
    } catch (err) {
      setError('Error al enviar el correo. Verifica el email ingresado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <form className="reset-form" onSubmit={(e) => e.preventDefault()}>
        <img src={logo} alt="logo" className="reset-logo" />
        <p className="reset-title">¿Olvidaste tu contraseña?</p>
        <div className="reset-description">
          <p>Ingresa tu correo electrónico para restablecer tu contraseña.</p>
        </div>
        <div className="reset-input-group">
          <div className="floating-label2">
            <input
              id="email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
              placeholder=" "
            />
            <label htmlFor="email">Email</label>
          </div>
        </div>

        <button
          type="button"
          className="reset-send-btn"
          onClick={handlePasswordReset}
          disabled={loading || !email}
        >
          {loading ? 'Enviando...' : 'Enviar correo de restablecimiento'}
        </button>

        {message && <p className="reset-success">{message}</p>}
        {error && <p className="reset-error">{error}</p>}

        <div className="reset-footer">
          ¿Ya tienes una cuenta?{' '}
          <span className="reset-link" onClick={() => handleTabChange('login')}>
            Inicia sesión aquí.
          </span>
        </div>
      </form>
    </div>
  );
};

export default OlvidasteContrasenia;
